// extracted by mini-css-extract-plugin
module.exports = {"container":"Lt-9ZdQIiseiWgGHgLie1","groupsList":"kqH8nj9Oiq1U5-72prc-o"};